export const SIGNATURE_Y_SIZE = 177;
